import { TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { NumericFormat } from 'react-number-format';
import { IGhgDetails } from '../../../../shared/services/generated-report/generated-report.model';

export const ReportingGhgTableSegment: FunctionComponent<{ title: React.ReactNode, data: IGhgDetails, showPrevious: boolean, }> = ({ title, data, showPrevious }) => {
  return (
    <TableRow>
      <TableCell scope='row' sx={{ fontWeight: 600 }}>
        {title}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'white', color: 'primary.dark' }}>
        {data.baseYearEmission ? <NumericFormat value={data.baseYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.baseYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.baseYearEmission === null ? '-' : ''}
      </TableCell>
      {showPrevious &&
        <TableCell scope='row' sx={{ backgroundColor: 'lightGrey.main', color: 'primary.dark' }}>
          {data.previousYearEmission ? <NumericFormat value={data.previousYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.previousYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
              data.previousYearEmission === null ? '-' : ''}
        </TableCell>}
      <TableCell scope='row' sx={{ backgroundColor: 'secondary.light', color: 'primary.dark' }}>
        {data.currentYearEmission ? <NumericFormat value={data.currentYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.currentYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.currentYearEmission === null ? '-' : ''}
      </TableCell>
    </TableRow>
  )
}